import React, {useEffect} from 'react';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {PaymentRequestView} from './PaymentRequestView';
import {useControllerProps} from '../Widget/ControllerContext';
import {ErrorMessage} from '../constants';

export enum ErrorViewDataHook {
  root = 'ErrorViewDataHook.root',
  view = 'ErrorViewDataHook.view',
}

export const ErrorView = () => {
  const {
    paymentRequestStore: {sendPaymentRequestErrorPageLoadBIEvent},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();

  useEffect(
    () => {
      sendPaymentRequestErrorPageLoadBIEvent(ErrorMessage.ERROR);
    },
    /* eslint-disable react-hooks/exhaustive-deps */ []
  );

  return (
    <div data-hook={ErrorViewDataHook.root}>
      <PaymentRequestView
        dataHook={ErrorViewDataHook.view}
        title={localeKeys.checkout.payLinks.generalError.title()}
        subtitle={localeKeys.checkout.payLinks.generalError.subtitle()}
      />
    </div>
  );
};
